import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { OnboardingEmailModalProps } from './OnboardingEmailModal.props';
import useOnboardingEmailModal from './useOnboardingEmailModal';

type OnboardingEmailModalContextValue = ReturnType<typeof useOnboardingEmailModal> & {
  companyName?: string | null;
};

const OnboardingEmailModalContext = createContext<OnboardingEmailModalContextValue | null>(null);

type OnboardingEmailModalProviderProps = Omit<OnboardingEmailModalProps, 'onClose'> & {
  children: ReactNode;
};

export const OnboardingEmailModalProvider: FC<OnboardingEmailModalProviderProps> = ({
  children,
  open,
  cmdId,
  measurementDateId,
  companyId,
  companyName,
}) => {
  const state = useOnboardingEmailModal({
    open,
    cmdId,
    measurementDateId,
    companyId,
    companyName,
  });

  const contextValue = useMemo(
    () => ({ ...state, companyName }),
    [state, companyName]
  );

  return (
    <OnboardingEmailModalContext.Provider value={contextValue}>
      {children}
    </OnboardingEmailModalContext.Provider>
  );
};

export const useOnboardingEmailModalContext = (): OnboardingEmailModalContextValue => {
  const context = useContext(OnboardingEmailModalContext);
  if (!context) {
    throw new Error('useOnboardingEmailModalContext must be used within OnboardingEmailModalProvider');
  }
  return context;
};
